<ng-container *ngIf="TREE_DATA?.length">
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl"
    [ngClass]="{'tree-view': isView, 'has-error': hasError(),'tree-has-dropdown':stopAutoParentSelection}">

    <mat-tree-node class="has-parent tree-node" [ngClass]="'level-' + node.level" [class.no-child]="!node.child.length" [style.display]="
        (isView && !node.is_checked)
        ||
        (searchText && hideLeafNode(node) && !showParentNode(node))
        ? 'none' : 'flex'" *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding>

      <mat-checkbox [matTooltip]="node.name" class="checklist-leaf-node" [checked]="checklistSelection.isSelected(node)"
        (change)="todoLeafItemSelectionToggle(node); selectedItem();">{{node.name}}</mat-checkbox>
    </mat-tree-node>

    <mat-tree-node class="parent tree-node" *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding
      [ngClass]="'level-' + node.level" [style.display]="hideParentNode(node) && hideLeafNode(node) ? 'none' : 'flex'"
      [class.active]="treeControl.isExpanded(node)">

      <button mat-icon-button matTreeNodeToggle type="button">
        <mat-icon class="mat-icon-rtl-mirror">
          {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
        </mat-icon>
      </button>

      <mat-checkbox [matTooltip]="node.name" [checked]="checklistSelection.isSelected(node)" [indeterminate]="descendantsPartiallySelected(node)"
        (change)="todoItemSelectionToggle(node);">
        {{node.name}}
      </mat-checkbox>
    </mat-tree-node>

  </mat-tree>
</ng-container>
<p class="has-error" *ngIf="hasError() && !stopAutoParentSelection">{{"forms.Required" | translate}}</p>
